import axios from 'axios'
import dayjs from 'dayjs'
import { GetToken } from 'services/Session'

const store = require('store')

export async function GetSetting(setSetting) {
	let defaultSetting = {
		"address": "<b>Back Office HSI AbdullahRoy</b><br />Dagen RT05, Gumuk, Ringinharjo, Bantul<br />Bantul, Daerah Istimewa Yogyakarta 55712<br />",
		"courier.code": "sicepat,tiki,jne,pos,lion,jnt",
		"db.migration.version": "0078",
		"db.seed.version": "0020",
		"description": "Pernik HSI menyediakan berbagai merchandise resmi HSI AbdullahRoy mulai dari Mukena, Kemko, Sarung, Rosal, Kitab, Kalender, Alat Tulis, dan lain sebagainya. Sebagian dari keuntungan digunakan sebagai penunjang dakwah HSI AbdullahRoy.",
		"facebook_url": "https://facebook.com/pernikhsi.official",
		"instagram_post_url": "https://www.instagram.com/p/C9wL29bSUzl/",
		"instagram_url": "https://instagram.com/pernikhsi.official",
		"origin_address.city.id": "501",
		"whatsapp_url": "https://wa.me/6281231000046",
	}
	let setting
	try {
		setting = await JSON.parse(store.get('setting'))
	} catch (e) {}
	if (!setting?.expiredAt || dayjs().isAfter(dayjs(setting?.expiredAt))) {
		try {
			let res = await axios.get('/api/v1/setting', {headers: { Authorization: 'Bearer ' + GetToken().access_token }})
			setting = {data: res?.data, expiredAt: dayjs().add(1, 'day')}
			store.set('setting', JSON.stringify(setting))
		} catch (e) {}
	}
	setSetting(setting?.data?? defaultSetting)
}

export async function SetSetting(setting) {
	try {
		let res = await axios.post('/api/v1/setting', setting, {headers: { Authorization: 'Bearer ' + GetToken().access_token }})
		setting = {data: res?.data, expiredAt: dayjs().add(1, 'day')}
		store.set('setting', JSON.stringify(setting))
		return res?.data
	} catch (e) {
		return await GetSetting()
	}
}
